import { Platform } from "react-native";
import {
  Svg,
  Defs,
  Circle,
  Polyline,
  Rect,
  Line,
  Text,
  Use,
} from "react-native-svg";

const MessDiagramm = ({
  size,
  data,
  minArea,
  maxArea,
  minValue,
  maxValue,
  noComponent,
  style,
}) => {
  const textstyle = style
    ? Array.isArray(style)
      ? Object.assign({}, ...style)
      : style
    : undefined;

  const viewX = 0;
  const viewY = 0;
  const viewWidth = 2800;
  const viewHeight = 1400;

  const calcXPoint = (time) => {
    let tm = new Date(time);
    let zeitwidth = maxTime - minTime;
    tm -= minTime;
    if (zeitwidth === 0) return 200;
    else return (tm * (viewWidth - 200)) / zeitwidth + 200;
  };
  const calcYPoint = (y) => {
    let valuewidth = maxValue + 1 - (minValue - 1);

    y -= minValue - 1;

    return viewHeight - (y * (viewHeight - 200)) / valuewidth - 200;
  };
  const checkArea = (value) => {
    if (minArea || maxArea) {
      if ((!maxArea || value <= maxArea) && (!minArea || value >= minArea))
        return true;
      else return false;
    } else return true;
  };
  let maxTime;
  let minTime;
  var bubbles = [];
  data.forEach((item) => {
    if (item.value !== -99) {
      if (!minValue || item.value < minValue) minValue = item.value;
      if (!maxValue || item.value > maxValue) maxValue = item.value;

      let tm = new Date(item.time);
      if (!minTime || tm < minTime) minTime = tm;
      if (!maxTime || tm > maxTime) maxTime = tm;
    }
  });
  data.forEach((item, index) => {
    if (item.value !== -99) {
      let x = calcXPoint(item.time);
      let y = calcYPoint(item.value);

      let errorvalue = !checkArea(item.value);

      if (errorvalue)
        bubbles.push(
          noComponent ? (
            `<Use href="#kreis" x="${x}" y="${y}" fill="${"red"}" />`
          ) : (
            <Use key={`BK_${index}`} href="#kreis" x={x} y={y} fill={"red"} />
          )
        );
      else
        bubbles.push(
          noComponent ? (
            `<Use href="#punkt" x="${x}" y="${y}" fill="${"green"}" />`
          ) : (
            <Use key={`BP_${index}`} href="#punkt" x={x} y={y} fill={"green"} />
          )
        );
    }
  });

  const getPoints = () => {
    let res = "";
    data.forEach((item) => {
      if (item.value !== -99) {
        if (res.length > 0) res += noComponent ? " " : ", ";
        res += calcXPoint(item.time);
        res += noComponent ? "," : " ";
        res += calcYPoint(item.value);
      }
    });
    return res;
  };

  const startxline = calcXPoint(minTime);
  const startyline = calcYPoint(minValue - 1);
  const endxline = calcXPoint(maxTime);
  const endyline = calcYPoint(maxValue + 1);

  const useArea = () => {
    return (maxArea !== 0 || minArea !== 0);
  };

  const areaInView = () => {
    return startYArea()<endYArea();
  }

  const startYArea = () => {
    if (useArea()) {
      if (maxArea) return calcYPoint(Math.min(maxArea, maxValue + 1));
      else return endyline;
    }
    return 0;
  };
  const endYArea = () => {
    if (useArea()) {
      if (minArea) return calcYPoint(Math.max(minArea, minValue - 1));
      else return startyline;
    }
    return 0;
  };

  const scalacnt = maxValue - minValue + 1;
  const scaladiv = Math.round(scalacnt / 15 + 0.5);

  const showScalaValue = (value) => {
    return value % scaladiv == 0;
  };
  var showscalaval = false;
  var scala = [];
  for (let i = minValue; i <= maxValue + 1; i++) {
    //if (scalacnt <= 15 || showscalaval) {
    if (showScalaValue(i)) {
      let yline = calcYPoint(i);
      scala.push(
        noComponent ? (
          `<Line x1="${startxline}" y1="${yline}" x2="${endxline}" y2="${yline}" stroke="${"lightgray"}" strokeWidth="${2}" />`
        ) : (
          <Line
            key={`SL_${i}`}
            x1={startxline}
            y1={yline}
            x2={endxline}
            y2={yline}
            stroke={"lightgray"}
            strokeWidth={2}
          />
        )
      );
      if (i <= maxValue)
        scala.push(
          noComponent ? (
            `<Text x="${
              startxline - 20
            }" y="${yline}" font-size="${70}" fill="${"#000000"}" stroke="${"#000000"}" stroke-width="${0}" text-anchor="end" dominant-baseline="middle">${i}°C</Text>`
          ) : (
            <Text
              key={`ST_${i}`}
              x={startxline - 20}
              y={yline}
              fontSize={70}
              fontFamily={
                Platform.OS !== "ios" && textstyle
                  ? textstyle.fontFamily
                  : undefined
              }
              fill={textstyle ? textstyle.color : "#000000"}
              stroke={textstyle ? textstyle.color : "#000000"}
              strokeWidth={0}
              textAnchor="end"
              alignmentBaseline="middle"
            >{`${i}°C`}</Text>
          )
        );
    }
    showscalaval = !showscalaval;
  }

  if (noComponent)
    return `
    <Svg width="${size}" height="${size / 2}" viewBox="${viewX} ${viewY} ${
      viewWidth + 20
    } ${viewHeight}">
      <Defs>
        <Circle id="kreis" stroke="${"#000000"}" strokeWidth="${2.5}" r="${12.5}" />
        <Circle id="punkt" stroke="${"#000000"}" strokeWidth="${0.5}" r="${6}" />
        <Polyline id="values" points="${getPoints()}" />
      </Defs>
      <Rect x="${startxline}" y="${0}" width="${viewWidth - 200}" height="${
      viewHeight - 200
    }" fill="${"#fffff0"}" />
      ${
        areaInView() &&
        `<Rect x="${startxline}" y="${startYArea()}" width="${
          viewWidth - 200
        }" height="${endYArea() - startYArea()}" fill="${"#eeffee"}" />`
      }
      <Line x1="${startxline}" y1="${startyline}" x2="${endxline}" y2="${startyline}" stroke="${"#000000"}" strokeWidth="${3}" />
      <Line x1="${startxline}" y1="${startyline}" x2="${startxline}" y2="${endyline}" stroke="${"#000000"}" strokeWidth="${3}" />
      ${scala}
      <Use href="#values" fill="${"none"}" stroke="${"lightgray"}" strokeWidth="${7}" />
      <Use href="#values" fill="${"none"}" stroke="${"green"}" strokeWidth="${3}" />
      ${bubbles}
    </Svg>`;

  return (
    <Svg
      width={size}
      height={size / 2}
      viewBox={`${viewX} ${viewY} ${viewWidth + 20} ${viewHeight}`}
    >
      <Defs>
        <Circle id="kreis" stroke={"#000000"} strokeWidth={2.5} r={12.5} />
        <Circle id="punkt" stroke={"#000000"} strokeWidth={0.5} r={6} />
        <Polyline id="values" points={getPoints()} />
      </Defs>
      <Rect
        x={startxline}
        y={0}
        width={viewWidth - 200}
        height={viewHeight - 200}
        fill={"#fffff0"}
      />
      {areaInView() && (
        <Rect
          x={startxline}
          y={startYArea()}
          width={viewWidth - 200}
          height={endYArea() - startYArea()}
          fill={"#eeffee"}
        />
      )}
      <Line
        x1={startxline}
        y1={startyline}
        x2={endxline}
        y2={startyline}
        stroke={textstyle ? textstyle.borderColor : "#000000"}
        strokeWidth={3}
      />
      <Line
        x1={startxline}
        y1={startyline}
        x2={startxline}
        y2={endyline}
        stroke={textstyle ? textstyle.borderColor : "#000000"}
        strokeWidth={3}
      />
      {scala}
      <Use href="#values" fill={"none"} stroke={"lightgray"} strokeWidth={7} />
      <Use href="#values" fill={"none"} stroke={"green"} strokeWidth={3} />
      {bubbles}
    </Svg>
  );
};

export default MessDiagramm;
